import React from 'react';
import { injectIntl, type IntlShape } from '@atlassian/jira-intl';
import ChangeIndicator from '@atlassian/jira-portfolio-3-portfolio/src/common/view/change-indicator';
import commonMessages from '@atlassian/jira-portfolio-3-portfolio/src/common/view/messages';
import LegendContainer from '../legend-container';
import LegendItems from '../legend-items';
import messages from '../messages';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from '../styles.module.css';
import type { Props } from './types';

function ScenarioChangesLegend({
	intl,
	ChangeIndicatorComponent = ChangeIndicator,
}: Props & {
	intl: IntlShape;
}) {
	const legendItems = [
		{
			icon: (
				<>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<div className={`${styles.changeIndicatorContainer} ${styles.bar}`}>
						<ChangeIndicatorComponent appearance="bar" />
					</div>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<div className={`${styles.changeIndicatorContainer} ${styles.triangle}`}>
						<ChangeIndicatorComponent appearance="triangle" />
					</div>
				</>
			),
			text: intl.formatMessage(commonMessages.unsavedChanges),
		},
	];
	return (
		<LegendContainer
			title={intl.formatMessage(messages.scenarioChangesLegendHeader)}
			childrenMaxWidth="400px"
		>
			<LegendItems items={legendItems} />
		</LegendContainer>
	);
}

export default injectIntl(ScenarioChangesLegend);
